export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  dateStart: state => state.dateStart,
  dateEnd: state => state.dateEnd,
  viewBy: state => state.viewBy,
  technician: state => state.technician,
  calibrates: state => state.calibrates,
  calibrate: state => state.calibrate,
  calibrateEvents: state => state.calibrateEvents,
  calibrateRequests: state => state.calibrateRequests,
  calibrateEvent: state => state.calibrateEvent,
  calibrateEventCurrent: state => state.calibrateEventCurrent,
  scans: state => state.scans,
  highlightSave: state => state.highlightSave,
  isCalibrateChecked: state => state.isCalibrateChecked,
  calibrateServiceRates: state => state.calibrateServiceRates,
  repairlines: state => state.repairlines,
  calibrateCounts: state => state.calibrateCounts,
  isChange: state => state.isChange,
  isCalibrateEventDialog: state => state.isCalibrateEventDialog,
  requestServices: state => state.requestServices,
  invoicePreferences: state => state.invoicePreferences,
  refreshRate: state => state.refreshRate,
  refreshRates: state => state.refreshRates,
  locationCalibrates: state => state.locationCalibrates,
  pendingServiceIds: state => state.pendingServiceIds,
  showAll: state => state.showAll,
  pendingStatusChange: state => state.pendingStatusChange,
  pricingRuleResults: state => state.pricingRuleResults
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/getters.js